/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PortfolioShareType = "FOLDERS" | "ITEMS" | "%future added value";
export type RenderPortfolioEmailsInput = {
    readonly message?: string | null;
    readonly portfolioItemIds?: ReadonlyArray<string | null> | null;
    readonly portfolioIds?: ReadonlyArray<string | null> | null;
    readonly recipientEmails: ReadonlyArray<string | null>;
    readonly showNotes?: boolean | null;
    readonly senderEmail: string;
    readonly senderName: string;
    readonly shareType: PortfolioShareType;
    readonly userId: string;
    readonly clientMutationId?: string | null;
};
export type RenderPortfolioEmailsMutationVariables = {
    readonly input: RenderPortfolioEmailsInput;
};
export type RenderPortfolioEmailsMutationResponse = {
    readonly renderPortfolioEmails: {
        readonly clientMutationId: string | null;
    } | null;
};
export type RenderPortfolioEmailsMutation = {
    readonly response: RenderPortfolioEmailsMutationResponse;
    readonly variables: RenderPortfolioEmailsMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "RenderPortfolioEmailsInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "renderPortfolioEmails",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RenderPortfolioEmailsPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clientMutationId",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "RenderPortfolioEmailsMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "RenderPortfolioEmailsMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "RenderPortfolioEmailsMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/RenderPortfolioEmailsMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '069b090a2237485c10f337e44853ac0a';
export default node;
